export const POSITIONS = [
  "Open Guard", "Closed Guard", "Mount", "Side Control", "Back Control",
  "Turtle", "Knee on Belly", "Standing", "North-South",
];

export const CATEGORIES = [
  "Submission", "Sweep", "Pass", "Escape", "Takedown", "Transition", "Control", "Guard Retention",
];

export const BELTS = ["White", "Blue", "Purple", "Brown", "Black"];

export const BELT_COLORS = {
  White: "#e5e7eb",
  Blue: "#3b82f6",
  Purple: "#8b5cf6",
  Brown: "#92400e",
  Black: "#111111",
};

export const CATEGORY_COLORS = {
  Submission: "#E63946",
  Sweep: "#007AFF",
  Pass: "#f59e0b",
  Escape: "#10b981",
  Takedown: "#a855f7",
  Transition: "#06b6d4",
  Control: "#ec4899",
  "Guard Retention": "#84cc16",
};

export const USER_THUMB = "/user-technique.jpg";

export const PLATFORM_THUMB = "/platform-technique.jpg";

// Legacy alias — kept so imports don't break, but always resolves to the user thumb (no more athletic photo).
export const FALLBACK_THUMB = USER_THUMB;

export const SCOPE_META = {
  platform: { emoji: "🌐", label: "Platform" },
  gym: { emoji: "🏫", label: "Gym" },
  personal: { emoji: "👤", label: "Personal" },
};
